import { render, staticRenderFns } from "./My_Friends.vue?vue&type=template&id=1a048510&scoped=true"
import script from "./My_Friends.vue?vue&type=script&lang=js"
export * from "./My_Friends.vue?vue&type=script&lang=js"
import style0 from "./My_Friends.vue?vue&type=style&index=0&id=1a048510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a048510",
  null
  
)

export default component.exports